export const BASE_API_URL =
  "https://vladyslav-meal-project-default-rtdb.firebaseio.com";
